<div class="footer-container">
    <div class="wpx_wrap vitrine-footer">
        <div>© Prixtel</div>
    </div>
</div>
